import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-matches-list',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-matches-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonMatchesListComponent {
  nSubItem = Array.from({ length: this.getRandomNumber(3, 1) }, (_, i) => i);

  getRandomNumber(max: number, min: number = 1) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
